import React, { useState, useRef } from "react";

import Row from "components/Row";
import { Input } from "components/Inputs/Input";
import { PrimaryButton } from "components/Buttons/PrimaryButton";
import Col from "components/Col";
import { uploadImageToStorage } from "modules/profile/firebase";
import ProfilePic from "modules/profile/ProfilePic";
import { signUp } from "../firebase";
import { AuthCardTitle, LinkContainer } from "../styled";

export default function SignUpPage({ history }) {
  const [form, setForm] = useState({
    name: "",
    photo_url: "",
    email: "",
    password: "",
    phone: ""
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [user] = useState(null);
  const [loading, setLoading] = useState(false);

  const photoInputRef = useRef(null);

  const handleInput = event => {
    setForm({
      ...form,
      [event.target.name]: event.target.value
    });
  };

  async function submit(e) {
    e.preventDefault();
    // upload image
    setLoading(true);
    try {
      let profileImageUrl = "https://i.ibb.co/SdQL2QZ/placeholderpic.png";
      if (selectedImage) {
        profileImageUrl = await uploadImageToStorage(
          selectedImage,
          selectedImage.name
        );
      }
      var data = {
        ...form,
        photo_url: profileImageUrl
      };
      await signUp(data);
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false);
    }
  }

  function openBrowseWindow() {
    photoInputRef.current.click();
  }

  return (
    <React.Fragment>
      <AuthCardTitle>Sign Up</AuthCardTitle>
      <form onSubmit={submit}>
        <Col style={{ alignItems: "center", marginTop: 16 }}>
          <ProfilePic
            onPress={openBrowseWindow}
            selectedImage={selectedImage}
            user={user}
          />
          <input
            ref={photoInputRef}
            type="file"
            accept="image/x-png,image/gif,image/jpeg"
            onChange={e => {
              if (e.target.files.length !== 0) {
                const file = e.target.files[e.target.files.length - 1];
                setSelectedImage(file);
              }
            }}
            style={{ display: "none" }}
          />
        </Col>
        <Input
          required
          type="text"
          label="Name"
          name="name"
          onChange={handleInput}
          margin="normal"
        />
        <Input
          required
          type="email"
          id="outlined-email"
          label="Email"
          name="email"
          onChange={handleInput}
          margin="normal"
        />
        <Input
          required
          label="Password"
          name="password"
          type="password"
          onChange={handleInput}
          margin="normal"
        />
        <Input
          required
          label="Confirm Password"
          name="password"
          type="password"
          onChange={handleInput}
          margin="normal"
        />
        <Input
          required
          label="Phone Number"
          name="phone"
          type="number"
          onChange={handleInput}
          margin="normal"
        />
        <LinkContainer>
          <span onClick={() => history.push("/login")}>Back to Login</span>
        </LinkContainer>
        <Row justify="space-between">
          <PrimaryButton type="submit" loading={loading}>
            SIGN UP
          </PrimaryButton>
        </Row>
      </form>
    </React.Fragment>
  );
}
